import { Icons } from "@/components/Icons/Icons";
import { Entity, EntityRecord } from "@/orm/types";
import { ActionIcon, Text } from "@mantine/core";
import { modals } from "@mantine/modals";

export const TrashButton = <T extends EntityRecord = EntityRecord>({
  entity,
  name,
}: {
  entity: Entity<T>;
  name: string;
}) => {
  const openDeleteModal = async () => {
    await modals.openConfirmModal({
      title: `Delete a ${entity.model.labels.singular}?`,

      children: (
        <Text size="md">
          Are you sure you want to delete "{name}"? This action is destructive
          and can't be undone.
        </Text>
      ),
      labels: {
        confirm: `Delete "${name}"`,
        cancel: "Cancel",
      },
      confirmProps: { color: "red" },
      onConfirm: async () => {
        entity.remove();
      },
    });
  };

  return (
    <ActionIcon variant={"light"} onClick={openDeleteModal}>
      <Icons.Delete />
    </ActionIcon>
  );
};
